<script setup lang="ts">
  import { HierarchicAplosFileViewModel } from '../models/HierarchicAplosFileViewModel'

  defineProps<{
    record: HierarchicAplosFileViewModel
    index?: number
    selectable?: boolean
    onCellClick?: (record: any, e?: Event) => void
  }>()

  function countFiles(rec: any) {
    return (
      1 + (rec?.rootItem != null ? 1 : 0) + (Array.isArray(rec.children) ? rec.children.length : 0)
    )
  }
</script>

<template>
  <div :class="{ 'cursor-pointer': selectable }">
    <a-tooltip>
      <template #title>Files in group</template>
      {{ countFiles(record) }}
    </a-tooltip>
  </div>
</template>
